import styled from "styled-components/macro";

import LeftSection from "./LeftSection";
import RightSection from "./RightSection";

const MiniProfile = () => {
  return (
    <MiniProfileWraper>
      <PhotoAndDataWrapper>
        <LeftSection />
        <RightSection />
      </PhotoAndDataWrapper>
    </MiniProfileWraper>
  );
};

const PhotoAndDataWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-grow: 1;
  max-width: 100%;
  min-width: 0;
`;

const MiniProfileWraper = styled.div`
  padding-top: 4px;
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export default MiniProfile;
